import { Component, Inject, OnInit} from '@angular/core';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { FormGroup, FormBuilder } from '@angular/forms';
import { CoreService } from 'src/app/applicationModules/core/services/coreService/core.service';
import { ToastrService } from 'ngx-toastr';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { StatusConstant } from '../status/status-constant';
import { LoaderService } from '../../shared/loader/loader.service';

@Component({
  selector: 'app-addupdateProcessStage',
  templateUrl: './addupdateProcessStage.component.html',
  styleUrls: ['./addupdateProcessStage.component.scss'] 
})

export class AddUpdateProcessStageComponent implements OnInit {
  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;     
  spinner:boolean=false;
  OfficeIDList: any=[];
  myOfficeID: any; 

  stageProcessList:any=[]=[];
  processStageID:number=0;
  buttonForStageProcess:boolean=false;
  taskTemplateID:number=0;

  constructor(public dialogRef: MatDialogRef<AddUpdateProcessStageComponent>,  
    private formBuilder: FormBuilder,private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private coreService: CoreService,
    private toastr: ToastrService,private statusConst: StatusConstant,
    private loaderService: LoaderService, @Inject(MAT_DIALOG_DATA) public data: any,) {   
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    if(encryptedtoken!=null){
      const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey,encryptedtoken);   
      this.currentUser = jwt_decode(token); 
      var offices=JSON.parse(sessionStorage.getItem('officeList'));
      offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID);
      if(oe.isMyoffice==true)
        this.myOfficeID=oe.officeID;
      });
    } 
  }  
  
   ngOnInit(): void {     
    this.getDashboardProcessStages(); 
   }     
       
   getDashboardProcessStages() {
    var ReqModel = {
       userID: this.currentUser.UID,
       organizationID: Number(this.organizationId),
       databaseID: Number(this.databaseId),
       officeID:this.myOfficeID,
     }
    this.coreService.getAllActiveStages(ReqModel).subscribe((response) => {
      if (response != undefined) {
        if (response.status == this.statusConst.statusSuccess && response.data != null) {
          this.stageProcessList=response.data;
        }else{
          this.stageProcessList=[];
        }
      }else{
        this.stageProcessList=[];
      }
    });
   }

 
  saveProcessStage() {    
    if(this.data.AddFrom== "Manage Task List Templates"){
     this.setProcessStageforTaskTemplate();
    }
    if(this.data.AddFrom== "Record Document Folders"){
     this.setProcessStagetoDocumentFolderTemplate();
    }
    if(this.data.AddFrom== "TaskList Group"){
     this.setProcessStageforTasklistGroup();
    }
    if(this.data.AddFrom== "Core Document Folders"){
     this.setProcessStageForCoreDocumentFolder();
    }
    
  }

  setProcessStageforTaskTemplate(){
    var ReqModel = {     
      tasktemplateID: Number(this.data.taskTemplateID),
      processStageID: Number(this.processStageID),
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList
    }
    this.loaderService.show();
    this.buttonForStageProcess = false;
    this.spinner = true;
    this.coreService.setProcessStageforTaskTemplate(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.spinner = false;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.dialogRef.close('Added');
          this.toastr.success('Selected stage folder added in task template.', '', {
            timeOut: 3000,
          });
          this.loaderService.hide();         
        } else {         
          this.loaderService.hide();
        }
      } else {       
        this.loaderService.hide();
      }
    });
  }
 

  setProcessStagetoDocumentFolderTemplate(){
    var ReqModel = {     
      templateID: Number(this.data.taskTemplateID),
      processStageID: Number(this.processStageID),
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList
    }
    this.loaderService.show();
    this.buttonForStageProcess = false;
    this.spinner = true;
    this.coreService.setProcessStagetoDocumentFolderTemplate(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.spinner = false;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.dialogRef.close('Added');
          this.toastr.success('Selected stage folder added in task template.', '', {
            timeOut: 3000,
          });
          this.loaderService.hide();         
        } else {         
          this.loaderService.hide();
        }
      } else {       
        this.loaderService.hide();
      }
    });
  }


  setProcessStageforTasklistGroup(){
    var ReqModel = {     
      tasklistID: Number(this.data.tasklistID),
      tasklistGroupID:Number(this.data.tasklistGroupID),
      processStageID: Number(this.processStageID),
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList
    }
    this.loaderService.show();
    this.buttonForStageProcess = false;
    this.spinner = true;
    this.coreService.setProcessStageforTasklistGroup(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.spinner = false;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.dialogRef.close('Added');
          this.toastr.success('Selected stage folder added in task template.', '', {
            timeOut: 3000,
          });
          this.loaderService.hide();         
        } else {         
          this.loaderService.hide();
        }
      } else {       
        this.loaderService.hide();
      }
    });
  }

  setProcessStageForCoreDocumentFolder(){
    var ReqModel = {     
      documentFolderID: Number(this.data.documentFolderID),
      processStageID: Number(this.processStageID),
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList
    }
    this.loaderService.show();
    this.buttonForStageProcess = false;
    this.spinner = true;
    this.coreService.setProcessStageForCoreDocumentFolder(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.spinner = false;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.dialogRef.close('Added');
          this.toastr.success('Selected stage folder added in task template.', '', {
            timeOut: 3000,
          });
          this.loaderService.hide();         
        } else {         
          this.loaderService.hide();
        }
      } else {       
        this.loaderService.hide();
      }
    });
  }


  closepopUp() {
    this.spinner = false;
    this.buttonForStageProcess=false;
    this.processStageID = 0;    
    this.dialogRef.close();
  }

  SelectStatus(data){
    this.processStageID = data.processStageID;
    this.buttonForStageProcess = true; 
  }

 

}
